import { useMutation, useQuery } from '@apollo/client';
import { useCallback } from 'react';
import {
    CREATE_LESSON_FOLDER_SHARES,
    CreateLessonFolderSharesResponse,
    CreateLessonFolderSharesVariables,
    DELETE_LESSON_FOLDER_SHARES,
    DeleteLessonFolderShareResponse,
    DeleteLessonFolderShareVariables,
    GET_LESSON_FOLDER,
    GetLessonFolderResponse,
    GetLessonFolderVariables,
} from './gql';

export const useLessonFolder = (id: string) => {
    const { data, refetch, loading } = useQuery<GetLessonFolderResponse, GetLessonFolderVariables>(GET_LESSON_FOLDER, {
        variables: {
            where: {
                id,
            },
        },
        fetchPolicy: 'network-only',
    });
    const [createLessonFolderShares] = useMutation<CreateLessonFolderSharesResponse, CreateLessonFolderSharesVariables>(CREATE_LESSON_FOLDER_SHARES);
    const [deleteLessonFolderShare] = useMutation<DeleteLessonFolderShareResponse, DeleteLessonFolderShareVariables>(DELETE_LESSON_FOLDER_SHARES);

    const share = useCallback(
        async (emails: string[]) => {
            const resp = await createLessonFolderShares({
                variables: {
                    data: emails.map((email) => ({
                        email,
                        lessonFolder: {
                            connect: { id },
                        },
                        user: {
                            connect: { email },
                        },
                    })),
                },
            });

            return resp.data?.createLessonFolderShares ?? [];
        },
        [createLessonFolderShares, id],
    );

    const unshare = useCallback(
        async (ids: string[]) => {
            const removed = await deleteLessonFolderShare({
                variables: {
                    where: ids.map((share) => ({ id: share })),
                },
            });

            return removed.data?.deleteLessonFolderShares ?? [];
        },
        [deleteLessonFolderShare],
    );

    return {
        lessonFolder: data?.lessonFolder,
        loading,
        refetch,
        share,
        unshare,
    };
};
